import Card from '../components/card/Card';
import P from '../components/texts/p/P';
import Icon from '../components/icon/Icon';
import { formatCuit } from '../utils/Masks';

// Función para formatear fecha de YYYY-MM-DD a DD/MM/YYYY
const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

export interface OverdueData {
  id: number;
  id_global: string;
  type: string;
  application_product_line_id: number;
  due_date: string;
  days_overdue: number;
  monetization_amount: number;
  installment_number: number;
  total_installments: number;
  creditor_name: string;
  currency: string;
  cuit: string;
  company_name: string;
  rate_type_id?: number;
  rate_percentage?: number;
  status_type?: string;
  amount?: number;
  partial_payment_amount?: number;
}

interface GetOverdueColumnsProps {
  handleOpenModal: (row: OverdueData) => void;
}

export function getOverdueColumns({ handleOpenModal }: GetOverdueColumnsProps) {
  const headerCenterStyle = {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  };

  return [
    {
      name: <div style={headerCenterStyle}>Nº Aval</div>,
      selector: (row: OverdueData) => row.id_global,
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.id_global}
          </P>
        </Card>
      ),
      width: '5%',
    },
    {
      name: <div style={headerCenterStyle}>CUIT</div>,
      selector: (row: OverdueData) => formatCuit(row.cuit || ''),
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {formatCuit(row.cuit || '')}
          </P>
        </Card>
      ),
      width: '8%',
    },
    {
      name: <div style={headerCenterStyle}>Razón social</div>,
      selector: (row: OverdueData) => row.company_name,
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.company_name}
          </P>
        </Card>
      ),
      width: '22%',
      grow: 1,
    },
    {
      name: <div style={headerCenterStyle}>Instrumento</div>,
      selector: (row: OverdueData) => row.type,
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.type}
          </P>
        </Card>
      ),
      width: '7%',
    },
    {
      name: <div style={headerCenterStyle}>Acreedor</div>,
      selector: (row: OverdueData) => row.creditor_name,
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.creditor_name}
          </P>
        </Card>
      ),
      width: '7%',
    },
    {
      name: <div style={headerCenterStyle}>Nº cuota</div>,
      selector: (row: OverdueData) => 
        row.installment_number && row.total_installments 
          ? `${row.installment_number} de ${row.total_installments}` 
          : '-',
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.installment_number && row.total_installments 
              ? `${row.installment_number} de ${row.total_installments}`
              : '-'}
          </P>
        </Card>
      ),
      width: '6%',
    },
    {
      name: <div style={headerCenterStyle}>F. vencimiento</div>,
      selector: (row: OverdueData) => row.due_date,
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {formatDate(row.due_date)}
          </P>
        </Card>
      ),
      width: '8%',
    },
    {
      name: <div style={headerCenterStyle}>Divisa</div>,
      selector: (row: OverdueData) => row.currency,
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.currency}
          </P>
        </Card>
      ),
      width: '10%',
    },
    {
      name: <div style={headerCenterStyle}>Monto</div>,
      selector: (row: OverdueData) => row.monetization_amount,
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.monetization_amount.toLocaleString('es-AR')}
          </P>
        </Card>
      ),
      width: '12%',
    },
    {
      name: <div style={headerCenterStyle}>Días vencida</div>,
      selector: (row: OverdueData) => row.days_overdue,
      cell: (row: OverdueData) => (
        <Card>
          <P type='3' variant='neutral'>
            {row.days_overdue}
          </P>
        </Card>
      ),
      width: '10%',
    },
    {
      name: '',
      cell: (row: OverdueData) => (
        <Card display='flex' justifyContent='center'>
          <Icon 
            name='arrow_right_outline' 
            variant='info'
            width={20}
            height={20}
            onClick={() => handleOpenModal(row)}
            />
        </Card>
      ),
      width: '5%',
    },
  ];
}
